<template>
  <div>
    <v-divider v-if="iteration > 0" class="my-5"></v-divider>
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title>
          <div class="d-sm-flex align-content-center">
            <div class="text-uppercase font-weight-bold">{{ cartProduct.product|appTranslate('name') }}</div>
            <div class="my-3 my-sm-0">
              <v-chip color="blue" text-color="white" small class="mx-2">
                <v-icon small left>mdi-account-circle</v-icon>
                {{ cartProduct.owner }}
              </v-chip>
            </div>
            <div v-for="(equipment, k) of cartProduct.equipments" :key="k">
              <div v-if="equipment" class="ml-2">
                + {{ cartProduct.product.productEquipments[`${k}`]|appTranslate('name') }}
              </div>
            </div>
            <PriceDisplay class="ml-sm-auto float-right float-sm-none" :cart-product="cartProduct" :number-of-days="numberOfDays"/>
          </div>
        </v-list-item-title>
        <v-list-item-subtitle class="mt-2 mb-3">
          <v-chip small @click="openEditCartProduct(cartProduct)" class="mr-2" color="deep-purple accent-4" outlined>
            <v-icon small left>mdi-square-edit-outline</v-icon>
            {{ 'edit'|globalTranslate }}
          </v-chip>
          <v-chip small @click="removeCartProduct(iteration)" color="deep-purple accent-4" outlined>
            <v-icon small left>mdi-delete-variant</v-icon>
            {{ 'delete'|globalTranslate }}
          </v-chip>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <CartProductDialog
        v-on:valid="saveCartProduct"
        v-on:cancel="cartProductDialog = false"
        v-on:click:outside="cartProductDialog = false"
        v-bind:cart-product="cartProductToEdit"
        v-bind:display-cancel="false"
        v-bind:api-url="apiUrl"
        v-bind:is-active="cartProductDialog"
        v-bind:data="data"
        v-bind:number-of-days="numberOfDays"
    />
  </div>
</template>

<script>
import PriceDisplay from "@/components/PriceDisplay.vue";
import CartProductDialog from "@/components/CartProductDialog";
import Config from "@/config";

export default {
  name: "CartProductListItem",
  components: {PriceDisplay, CartProductDialog},
  data() {
    return {
      apiUrl: Config.API_URL,
      cartProductDialog: false,
      cartProductToEdit: null,
    };
  },
  methods: {
    openEditCartProduct(cartProduct) {
      this.cartProductToEdit = cartProduct;
      this.cartProductDialog = true;
    },
    removeCartProduct(cartProductIndex) {
      this.$store.dispatch("cart/remove", cartProductIndex);
    },
    saveCartProduct() {
      this.cartProductDialog = false;
      this.$store.dispatch("cart/updateTotals");
    },
  },
  props: {
    cartProduct: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    iteration: {
      type: Number,
      required: false,
      default() {
        return 0
      }
    },
    numberOfDays: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
